/**
 * 사용자 유형(beginner · advanced · expert) 관리 — 관리자만(서버가 403). 판정·막기는 서버(backend modules/userGrade)가 한다.
 */
const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';

async function call(method, path, body) {
    const res = await fetch(`${BASE_URL}${path}`, {
        method,
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'include',
    });
    const j = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(j.error || `HTTP ${res.status}`);
        err.response = { status: res.status, data: j };
        throw err;
    }
    return j;
}

export const listUserGrades = () => call('GET', '/user-grades');
export const setUserGrade = (usrid, grade) => call('PUT', `/user-grades/${encodeURIComponent(usrid)}`, { grade });
